"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEditorPdfPageSuffix = exports.getFilenameAndExtension = void 0;
const getFilenameAndExtension = (filename) => {
    let lastDotIndex = filename.lastIndexOf('.');
    const extension = filename.substr(++lastDotIndex);
    const name = filename.substr(0, lastDotIndex - 1);
    return { name, extension };
};
exports.getFilenameAndExtension = getFilenameAndExtension;
const getEditorPdfPageSuffix = (pageNumber, pages, characters = '') => {
    const charCodeBase = 97;
    const nbrOfLetters = 26;
    const index = pageNumber - 1;
    const charIndex = index % nbrOfLetters;
    const char = String.fromCharCode(charCodeBase + charIndex);
    if (characters.length > 10) {
        throw new Error('Too many recursions');
    }
    else if (pages / nbrOfLetters <= 1) {
        return char + characters;
    }
    return exports.getEditorPdfPageSuffix(Math.floor(index / nbrOfLetters) + 1, Math.ceil(pages / nbrOfLetters), char + characters);
};
exports.getEditorPdfPageSuffix = getEditorPdfPageSuffix;
